import { SubAbility } from './SubAbility';
export default SubAbility;
